import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatDialogModule } from '@angular/material/dialog';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { NasModelModule } from '@sama/ng-app-state';
import { SamaScrollSectionNavigationModule } from '@sama/ui-library';
import { Shared2DModule } from '../../../2d/shared/shared-2d.module';
import { PointCloudContentModule } from '../../../3d/point-cloud-content.module';
import { PointCloudHelpModalComponent } from '../../../core/outputs/annotation/annotation-shared/toolbars/static-toolbar/help-modal/point-cloud-help-modal.component';
import { SideViewToggleButtonComponent } from '../../../cross-team-shared/annotation/shared/toolbars/side-view-toggle-button/side-view-toggle-button.component';
import { SharedModule } from '../../../shared/shared.module';
import { AnnotationSharedModule } from '../annotation-shared/annotation-shared.module';
import { PointCloudLayoutComponent } from './point-cloud-layout.component';
import { PointCloudOutputComponent } from './point-cloud-output.component';

@NgModule({
  imports: [
    AnnotationSharedModule,
    CommonModule,
    FontAwesomeModule,
    FormsModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatDialogModule,
    MatTabsModule,
    MatTooltipModule,
    NasModelModule,
    PointCloudContentModule,
    SamaScrollSectionNavigationModule,
    SharedModule,
    Shared2DModule,
  ],
  declarations: [
    PointCloudHelpModalComponent,
    PointCloudLayoutComponent,
    PointCloudOutputComponent,
    SideViewToggleButtonComponent,
  ],
  exports: [PointCloudOutputComponent],
})
export class PointCloudModule {}
